import { useState } from "react";
import Header from "@/components/Header";
import TabsView from "@/components/TabsView";
import Footer from "@/components/Footer";
import DataTable from "@/components/DataTable";

const backtestingData = [
  {
    date: "2025-01-15",
    actual: "4935.62",
    predicted: "4940.17",
    difference: "+0.09%",
    accuracy: "99.91%"
  },
  {
    date: "2025-01-16",
    actual: "4950.73",
    predicted: "4945.89",
    difference: "-0.10%",
    accuracy: "99.90%"
  },
  {
    date: "2025-01-17",
    actual: "4985.12",
    predicted: "4979.35",
    difference: "-0.12%",
    accuracy: "99.88%"
  },
  {
    date: "2025-01-18",
    actual: "5002.45",
    predicted: "5010.87",
    difference: "+0.17%",
    accuracy: "99.83%"
  },
  {
    date: "2025-01-19",
    actual: "5015.78",
    predicted: "5018.92",
    difference: "+0.06%",
    accuracy: "99.94%"
  }
];

const Index = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("dashboard");

  const handleTabChange = (tabId: string) => {
    setActiveTab(tabId);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header 
        onToggleMenu={() => setMenuOpen(!menuOpen)} 
        menuOpen={menuOpen}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />
      
      <main className="flex-1 container mx-auto pt-32 pb-16 px-4">
        <TabsView 
          defaultValue={activeTab} 
          activeTab={activeTab}
          onTabChange={handleTabChange}
        >
          <DataTable data={backtestingData} />
        </TabsView>
      </main>
      
      <Footer />
    </div>
  );
};

export default Index;
